import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { subscribeFileTooLarge, MAX_UPLOAD_MB } from "@/lib/fileLimit";

/**
 * Global modal shown whenever the user tries to upload a file bigger than the
 * allowed limit. Mounted once at the app root; it listens to fileLimit events.
 */
export default function FileSizeLimitModal() {
  const [mb, setMb] = useState(null);

  useEffect(() => subscribeFileTooLarge((value) => setMb(value ?? "")), []);

  const close = () => setMb(null);
  if (mb === null) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-6"
         onClick={close} data-testid="file-size-limit-modal">
      <div className="bg-white max-w-sm w-full p-8 luxury-card" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-[#F5E9E9] flex items-center justify-center shrink-0">
            <AlertTriangle className="w-5 h-5 text-[#8C3A3A]" strokeWidth={1.75} />
          </div>
          <h3 className="font-serif text-xl">File troppo grande</h3>
        </div>
        <p className="text-sm text-[#707070] mb-6">
          {mb ? <>Il file selezionato pesa <strong>{mb} MB</strong>. </> : null}
          Il limite massimo consentito è di <strong>{MAX_UPLOAD_MB} MB</strong> per file.
          Riduci o comprimi il documento e riprova.
        </p>
        <div className="flex justify-end">
          <button onClick={close} className="btn-primary" data-testid="file-size-limit-close-btn">
            Ho capito
          </button>
        </div>
      </div>
    </div>
  );
}
